import { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Avatar,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import Layout from "../components/layout/Calayout";

const TeamManagementPage = () => {
 
  const [teamMembers, setTeamMembers] = useState([
    {
      id: 1,
      name: "Rajesh Kumar",
      email: "rajesh.kumar@cafirm.com",
      role: "Senior CA",
      status: "active",
      permissions: ["view_reports", "manage_clients"],
    },
    {
      id: 2,
      name: "Priya Sharma",
      email: "priya.sharma@cafirm.com",
      role: "Junior CA",
      status: "inactive",
      permissions: ["view_reports"],
    },
  ]);

  // State for dialog management
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [currentMember, setCurrentMember] = useState({
    name: "",
    email: "",
    role: "",
    permissions: [],
  });

  
  const roleOptions = [
    "Senior CA",
    "Junior CA",
    "Audit Manager",
    "Tax Consultant",
    "Admin",
  ];

  const permissionOptions = [
    { key: "view_reports", label: "View Reports" },
    { key: "manage_clients", label: "Manage Clients" },
    { key: "edit_tax_records", label: "Edit Tax Records" },
    { key: "financial_analysis", label: "Financial Analysis" },
  ];

  
  const handleSaveMember = () => {
    if (currentMember.id) {
    
      setTeamMembers(
        teamMembers.map((member) =>
          member.id === currentMember.id ? currentMember : member
        )
      );
    } else {
      // Add new member
      setTeamMembers([
        ...teamMembers,
        { ...currentMember, id: teamMembers.length + 1, status: "active" },
      ]);
    }
    setOpenAddDialog(false);
    // Reset current member
    setCurrentMember({ name: "", email: "", role: "", permissions: [] });
  };

  // Handler for deleting team member
  const handleDeleteMember = (id) => {
    setTeamMembers(teamMembers.filter((member) => member.id !== id));
  };

  // Toggle member status
  const handleToggleStatus = (id) => {
    setTeamMembers(
      teamMembers.map((member) =>
        member.id === id
          ? {
              ...member,
              status: member.status === "active" ? "inactive" : "active",
            }
          : member
      )
    );
  };

  // Render add/edit dialog
  const renderMemberDialog = () => (
    <Dialog
      open={openAddDialog}
      onClose={() => setOpenAddDialog(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {currentMember.id ? "Edit Team Member" : "Add New Team Member"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Name"
              value={currentMember.name}
              onChange={(e) =>
                setCurrentMember({
                  ...currentMember,
                  name: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={currentMember.email}
              onChange={(e) =>
                setCurrentMember({
                  ...currentMember,
                  email: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Role</InputLabel>
              <Select
                value={currentMember.role}
                label="Role"
                onChange={(e) =>
                  setCurrentMember({
                    ...currentMember,
                    role: e.target.value,
                  })
                }
              >
                {roleOptions.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Permissions
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {permissionOptions.map((perm) => (
                <Chip
                  key={perm.key}
                  label={perm.label}
                  color={
                    currentMember.permissions.includes(perm.key)
                      ? "primary"
                      : "default"
                  }
                  onClick={() => {
                    setCurrentMember((prev) => ({
                      ...prev,
                      permissions: prev.permissions.includes(perm.key)
                        ? prev.permissions.filter((p) => p !== perm.key)
                        : [...prev.permissions, perm.key],
                    }));
                  }}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenAddDialog(false)}>Cancel</Button>
        <Button onClick={handleSaveMember} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Layout>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h4">Team Management</Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => {
              setCurrentMember({
                name: "",
                email: "",
                role: "",
                permissions: [],
              });
              setOpenAddDialog(true);
            }}
          >
            Add Team Member
          </Button>
        </Box>

        <Card>
          <CardContent>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Permissions</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {teamMembers.map((member) => (
                    <TableRow key={member.id}>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar sx={{ mr: 2 }}>
                            {member.name.charAt(0)}
                          </Avatar>
                          {member.name}
                        </Box>
                      </TableCell>
                      <TableCell>{member.email}</TableCell>
                      <TableCell>{member.role}</TableCell>
                      <TableCell>
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {member.permissions.map((perm) => (
                            <Chip
                              key={perm}
                              label={
                                permissionOptions.find((p) => p.key === perm)
                                  ?.label || perm
                              }
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          ))}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Switch
                          checked={member.status === "active"}
                          onChange={() => handleToggleStatus(member.id)}
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex" }}>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setCurrentMember(member);
                              setOpenAddDialog(true);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteMember(member.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>

        {renderMemberDialog()}
      </Box>
    </Layout>
  );
};

export default TeamManagementPage;
